import * as React from 'react';
import { useTheme } from 'styled-components';

type Props = {
  embed?: string;
};

//レンダリング前に処理が実行されないようにした
//参考：https://www.gatsbyjs.com/docs/debugging-html-builds/
const isBrowser = typeof document !== `undefined`;

export const Timerex: React.FC<Props> = (props) => {
  const theme = useTheme();

  if (isBrowser) {
    let scriptEl = document.createElement('script');
    scriptEl.setAttribute('src', 'https://timerex.net/js/embed.js');
    document.body.appendChild(scriptEl);

    // アクセス時に読み込まれない場合があるので、タイムラグで発火するようにした
    setTimeout(function () {
      window.TimerexCalendar({
        primary_color: theme.backgroundColors.primary,
        disable_logo: true,
      });
    }, 500);
  }

  return <div id="timerex_calendar" data-url={props.embed} />;
};

//参考 https://developers.timerex.net/docs/widget/ZG9jOjIxMDcxOTUz-
